import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";

import { getCurios } from "../../../../MyApi/curior";
import { postCourierOrder } from "../../../../MyApi/orders";

const AppointCourierModal = ({
  show,
  onClose,
  refetch,
  orderId,
  // storeId,
}) => {
  const [formData, setFormData] = useState({
    courier_id: "",
    reason: "",
  });

  useEffect(() => {
    if (!show) {
      setFormData({
        courier_id: "",
        reason: "",
      });
    }
  }, [show]);

  const { data, isLoading: couriersLoading } = useQuery(
    ["couriers"],
    () => getCurios(),
    {
      enabled: show,
      refetchOnWindowFocus: false,
    }
  );

  const couriers =
    data?.data?.couiers ||
    data?.data?.couriers ||
    [];

  const mutation = useMutation(
    (postData) => postCourierOrder(postData, orderId),
    {
      onSuccess: (res) => {
        toast.success(res?.message || "تم تعيين السائق بنجاح");

        setFormData({
          courier_id: "",
          reason: "",
        });

        refetch?.();
        onClose?.();
      },

onError: (err) => {
  console.log("ASSIGN ERROR", err?.response?.data);

  toast.error(
    err?.response?.data?.message ||
    "حدث خطأ أثناء تعيين السائق"
  );
},
    }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.courier_id) {
      toast.error("يرجى اختيار السائق");
      return;
    }

    mutation.mutate({
      courier_id: Number(formData.courier_id),
      reason: formData.reason,
    });
  };

  const handleClose = () => {
    setFormData({
      courier_id: "",
      reason: "",
    });

    onClose?.();
  };

  return (
    <Modal isOpen={show} toggle={handleClose} className="add">
      <ModalHeader toggle={handleClose}>تعيين سائق</ModalHeader>

      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>السائق</Label>

            <Input
              type="select"
              name="courier_id"
              value={formData.courier_id}
              onChange={handleChange}
              disabled={couriersLoading}
            >
              <option value="">
                {couriersLoading
                  ? "جاري تحميل السائقين..."
                  : "اختر السائق"}
              </option>

              {couriers.map((courier) => (
                <option
                  key={courier.id}
                  value={courier.id}
                >
                  {courier.name}
                </option>
              ))}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>سبب التعيين</Label>

            <Input
              type="textarea"
              rows="4"
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              placeholder="أدخل سبب تعيين السائق"
            />
          </FormGroup>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={mutation.isLoading}
        >
          {mutation.isLoading
            ? "جاري الحفظ..."
            : "حفظ"}
        </Button>

        <Button
          className="btn btn-sm  btn-danger"
          onClick={handleClose}
          disabled={mutation.isLoading}
        >
          إلغاء
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AppointCourierModal;